import { render, staticRenderFns } from "./entry-name.vue?vue&type=template&id=bdc1d76e&"
import script from "./entry-name.vue?vue&type=script&lang=js&"
export * from "./entry-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports